<template>
    <div class="cart-preview" :class="{ active, processed, }" >
        <div class="cart-preview__top">
            <div class="cart-preview__title">Корзина <span v-if="cartItems.length" >({{ cartItems.length }})</span></div>
            <div @click.prevent="active = false" class="cart-preview__close"></div>
        </div>
        <div class="cart-preview__list">
            <div v-for="item in cartItems" :key="item.id" class="cart-preview__item">
                <div class="cart-preview__img"><a v-if="item.imgSrc" :href="item.url"><img :src="item.imgSrc" loading="lazy"/></a></div>
                <div class="cart-preview__desc">
                    <a class="cart-preview__name" :href="item.url" v-html="item.name" ></a>
                    <!-- <div class="cart-preview__info">65 мл </div> -->
                    <div class="cart-preview__quantity">
                        <quantity v-model="item.quantity" :step="+item.stepToAdd" @input="updateItem(item, 'quantity')" readonly ></quantity>
                        <div class="cart-preview__price">{{ item.sum }} руб.</div>
                    </div>
                </div>
                <div class="cart-preview__del"><a @click.prevent="remove(item)" class="del" href="#"></a></div>
            </div>
        </div>
        <div v-if="cartItems.length" class="cart-preview__bottom">
          <div class="cart-preview__line" v-if="$store.state.cart.delivery">
            Доставка: {{$store.state.cart.delivery['delivery-price']}} руб.
          </div>
            <div class="cart-preview__line">
                <a @click.prevent="clear()" class="cart-preview__remove" href="#">Очистить корзину</a>
                <div class="cart-preview__sum">Итого:<span class="cart-preview__price">{{ sum }} руб.</span></div>
            </div>
            <a class="btn btn-color" :href="cartUrl" >Перейти в корзину</a>
        </div>
    </div>
</template>

<script>

import Cart from '../mixins/Cart.js';

export default {
    name : 'CartPreview',
    mixins : [
        Cart,
    ],
    props : {
        cartUrl : {
            type : String,
            default : '/personal/cart/',
        },
    },
    data : () => ({
        processed : false,
        active : false,
    }),
    mounted(){
        /**
         * Закрытие превью корзины по клику вне ее
         */
        document.body.addEventListener("click", (event) => {
            const target = event.target,
                cartPreviwBtn = document.querySelector(".header-btns__item .cart"),
                cartPreviewBlock = document.querySelector(".cart-preview");

            if (!cartPreviewBlock) return;

            if ( cartPreviwBtn &&
                !cartPreviwBtn.contains(target)
                && !cartPreviewBlock.contains(target)
            ){
                // cartPreviewBlock.classList.remove("active");
                this.active = false;
            }
        });
    },
    watch : {
        active (active) {
            if (active && !this.cartItems.length) {
                this.active = false;
            }
        },
        cartItems : {
            deep : true,
            handler () {
                if (!this.cartItems.length) {
                    this.active = false;
                }
            },
        }
    },
    methods : {
        toggle () {
            this.active = !this.active;
        },
        clear () {
            this.processed = true;
            fetch('/ajax/v1/cart/clear/', {
                method : 'POST',
            })
            .then(() => {
                this.processed = false;
                this.$store.dispatch('loadCartData');
            });
        },
    },
}
</script>
